import { render, staticRenderFns } from "./courts.vue?vue&type=template&id=c6c9ec06&scoped=true"
import script from "./courts.vue?vue&type=script&lang=js"
export * from "./courts.vue?vue&type=script&lang=js"
import style0 from "./courts.vue?vue&type=style&index=0&id=c6c9ec06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c9ec06",
  null
  
)

export default component.exports